import React from 'react';
import { StyleSheet, View } from 'react-native';
import type { AddressType } from '@sweetgreen/garnish';
import { useBreakpointHelpers } from '@sweetgreen/garnish';

import { LocationSearchTypePicker } from '../../../../LocationsScreen/components/SearchBar/subcomponents';
import { LeftIcon } from './LeftIcon';
import { RightIcon } from './RightIcon';

export const LocationTypePickerHeader = ({
  locationSearchType,
  onSelectLocationType,
  onBack,
  onClose,
}: LocationTypePickerHeaderProps) => {
  const { isMobile } = useBreakpointHelpers();

  return (
    <View style={styles.chipsContainer}>
      {!isMobile && onBack ? <LeftIcon onPress={onBack} /> : null}

      <LocationSearchTypePicker
        searchType={locationSearchType}
        onSelect={onSelectLocationType}
      />

      {!isMobile && onClose ? <RightIcon onPress={onClose} /> : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  chipsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
});

type LocationTypePickerHeaderProps = {
  readonly locationSearchType: AddressType;
  readonly onSelectLocationType: (searchType: AddressType) => void;
  readonly onClose?: () => void;
  readonly onBack?: () => void;
};
